import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["input", "hint", "save"]

  check() {
    clearTimeout(this.timer)
    this.timer = setTimeout(() => this.lookup(), 400)
  }

  lookup() {
    const value = this.inputTarget.value.trim().toLowerCase()
    if (!value || value === this.data.get("original")) return this.render("muted", "")

    this.render("muted", '<i class="fas fa-spinner fa-spin"></i> Checking…', true)
    $.getJSON(this.data.get("url"), { email: value, user_id: this.data.get("userId") })
      .done((data) => {
        if (this.inputTarget.value.trim().toLowerCase() !== value) return // stale response
        data.available
          ? this.render("success", '<i class="fas fa-check-circle"></i> Available')
          : this.render("danger", '<i class="fas fa-times-circle"></i> This email is already in use by another account', true)
      })
      .fail(() => this.render("muted", "")) // fail open; the server still validates on save
  }

  render(kind, html, disable = false) {
    this.hintTarget.innerHTML = html
    this.hintTarget.className = `form-text text-${kind}`
    this.saveTarget.disabled = disable
    this.saveTarget.style.opacity = disable ? "0.5" : ""
    this.saveTarget.style.cursor = disable ? "not-allowed" : ""
  }
}
